/* =============================================
   FOOTBALL FIT — Shopify Theme JS
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 50);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Announcement bar dismiss ---------- */
  var announceClose = document.querySelector('.announce-close');
  var announceBar = document.querySelector('.announce-bar');
  if (announceClose && announceBar) {
    announceClose.addEventListener('click', function () {
      announceBar.style.display = 'none';
    });
  }

  /* ---------- Nav overlay ---------- */
  var navOverlay = document.getElementById('nav-overlay');
  var navBackdrop = document.getElementById('nav-overlay-backdrop');
  var navOpenBtns = document.querySelectorAll('[data-nav-open]');
  var navCloseBtns = document.querySelectorAll('[data-nav-close]');

  function openNav() {
    if (!navOverlay) return;
    navOverlay.classList.add('open');
    if (navBackdrop) navBackdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    if (!navOverlay) return;
    navOverlay.classList.remove('open');
    if (navBackdrop) navBackdrop.classList.remove('open');
    document.body.style.overflow = '';
  }
  navOpenBtns.forEach(function (btn) { btn.addEventListener('click', openNav); });
  navCloseBtns.forEach(function (btn) { btn.addEventListener('click', closeNav); });
  if (navBackdrop) navBackdrop.addEventListener('click', closeNav);

  /* ---------- Search overlay ---------- */
  var searchOverlay = document.getElementById('search-overlay');
  var searchOpenBtns = document.querySelectorAll('[data-search-open]');
  var searchCloseBtns = document.querySelectorAll('[data-search-close]');
  var searchInput = document.getElementById('search-overlay-input');
  var searchResults = document.getElementById('search-overlay-results');
  var searchTimer;

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 100);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  searchOpenBtns.forEach(function (btn) { btn.addEventListener('click', openSearch); });
  searchCloseBtns.forEach(function (btn) { btn.addEventListener('click', closeSearch); });

  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (q.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,vendor')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length === 0) {
              searchResults.innerHTML = '<p class="search-no-results">No results found for "' + escapeHtml(q) + '"</p>';
              return;
            }
            var html = '<p class="label">Results</p>';
            products.forEach(function (p) {
              html += '<a href="' + p.url + '" class="search-result-item">' +
                (p.featured_image ? '<img src="' + p.featured_image + '" alt="' + escapeHtml(p.title) + '">' : '<div style="width:64px;height:64px;background:#111"></div>') +
                '<div><p class="team">' + escapeHtml(p.vendor || '') + '</p><p class="name">' + escapeHtml(p.title) + '</p><p class="price">' + p.price + '</p></div>' +
                '</a>';
            });
            searchResults.innerHTML = html;
          })
          .catch(function () {});
      }, 250);
    });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ---------- Cart drawer (AJAX) ---------- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartBackdrop = document.getElementById('cart-drawer-backdrop');
  var cartOpenBtns = document.querySelectorAll('[data-cart-open]');
  var cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartBackdrop) cartBackdrop.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartBackdrop) cartBackdrop.classList.remove('open');
    document.body.style.overflow = '';
  }
  cartOpenBtns.forEach(function (btn) { btn.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  cartCloseBtns.forEach(function (btn) { btn.addEventListener('click', closeCart); });
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);

  function moneyFormat(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function renderCartItem(item) {
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    return '' +
      '<div class="cart-item" data-key="' + item.key + '">' +
        '<div class="cart-item-img"><img src="' + (item.image || '') + '" alt="' + escapeHtml(item.product_title) + '"></div>' +
        '<div class="cart-item-info">' +
          (item.vendor ? '<p class="variant">' + escapeHtml(item.vendor) + '</p>' : '') +
          '<p class="name">' + escapeHtml(item.product_title) + '</p>' +
          (variantLine ? '<p class="size">' + escapeHtml(variantLine) + '</p>' : '') +
          '<div class="cart-item-controls">' +
            '<div class="cart-item-qty">' +
              '<button type="button" data-qty-decrease>-</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-increase>+</button>' +
            '</div>' +
            '<div class="cart-item-price-remove">' +
              '<span class="cart-item-price">' + moneyFormat(item.final_line_price) + '</span>' +
              '<button type="button" class="cart-item-remove" data-item-remove aria-label="Remove">✕</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function renderCart(cart) {
    var body = document.getElementById('cart-drawer-body');
    var footer = document.getElementById('cart-drawer-footer');
    var countLabel = document.getElementById('cart-drawer-count');
    if (!body) return;

    if (countLabel) countLabel.textContent = '(' + cart.item_count + ' ' + (cart.item_count === 1 ? 'item' : 'items') + ')';

    document.querySelectorAll('.nav-cart-badge').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (cart.item_count === 0) {
      body.innerHTML = '' +
        '<div class="cart-drawer-empty">' +
          '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>' +
          '<p class="title">Your cart is empty</p>' +
          '<p class="sub">Add some jerseys to get started</p>' +
          '<button type="button" class="btn-secondary" data-cart-close>CONTINUE SHOPPING</button>' +
        '</div>';
      if (footer) footer.classList.add('hidden');
    } else {
      body.innerHTML = cart.items.map(renderCartItem).join('');
      if (footer) {
        footer.classList.remove('hidden');
        var subtotalEl = document.getElementById('cart-drawer-subtotal-amount');
        if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
      }
      body.querySelectorAll('[data-cart-close]').forEach(function (btn) { btn.addEventListener('click', closeCart); });
    }
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-qty-increase]');
    var decBtn = e.target.closest('[data-qty-decrease]');
    var removeBtn = e.target.closest('[data-item-remove]');
    if (incBtn || decBtn || removeBtn) {
      var row = e.target.closest('.cart-item');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var qtySpan = row.querySelector('.cart-item-qty span');
      var currentQty = parseInt(qtySpan.textContent, 10);
      if (incBtn) changeCartItem(key, currentQty + 1);
      if (decBtn) changeCartItem(key, Math.max(0, currentQty - 1));
      if (removeBtn) changeCartItem(key, 0);
    }
  });

  /* Quick-add buttons (product cards on collection/home pages) */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      addToCart(variantId, 1, btn);
    });
  });

  /* Product page add-to-cart form */
  var pdForm = document.getElementById('product-form');
  if (pdForm) {
    pdForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantInput = pdForm.querySelector('[name="id"]');
      var qtyInput = pdForm.querySelector('[name="quantity"]');
      var submitBtn = pdForm.querySelector('[type="submit"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      addToCart(variantInput.value, qty, submitBtn, false);
    });
  }

  function addToCart(variantId, quantity, btn, buyNow) {
    if (btn) { btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (buyNow) {
          window.location.href = '/checkout';
          return;
        }
        return fetchCart().then(function () { openCart(); });
      })
      .catch(function () {})
      .finally(function () { if (btn) btn.disabled = false; });
  }

  /* Initial cart render on page load so counts are correct */
  if (cartDrawer) fetchCart();

  /* ---------- Product detail page: size / qty / tabs ---------- */
  document.querySelectorAll('.pd-size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var group = btn.closest('.pd-size-grid');
      group.querySelectorAll('.pd-size-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var variantId = btn.getAttribute('data-variant-id');
      var hiddenInput = document.querySelector('#product-form [name="id"]');
      if (hiddenInput && variantId) hiddenInput.value = variantId;
    });
  });

  var qtyDecrease = document.querySelector('[data-pd-qty-decrease]');
  var qtyIncrease = document.querySelector('[data-pd-qty-increase]');
  var qtyDisplay = document.querySelector('[data-pd-qty-display]');
  var qtyHidden = document.querySelector('#product-form [name="quantity"]');
  if (qtyDecrease && qtyIncrease && qtyDisplay) {
    qtyDecrease.addEventListener('click', function () {
      var v = Math.max(1, parseInt(qtyDisplay.textContent, 10) - 1);
      qtyDisplay.textContent = v;
      if (qtyHidden) qtyHidden.value = v;
    });
    qtyIncrease.addEventListener('click', function () {
      var v = Math.min(10, parseInt(qtyDisplay.textContent, 10) + 1);
      qtyDisplay.textContent = v;
      if (qtyHidden) qtyHidden.value = v;
    });
  }

  var buyNowBtn = document.getElementById('pd-buy-now');
  if (buyNowBtn && pdForm) {
    buyNowBtn.addEventListener('click', function () {
      var variantInput = pdForm.querySelector('[name="id"]');
      var qty = qtyDisplay ? parseInt(qtyDisplay.textContent, 10) : 1;
      addToCart(variantInput.value, qty, buyNowBtn, true);
    });
  }

  document.querySelectorAll('.pd-tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-tab-target');
      document.querySelectorAll('.pd-tab-btn').forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('.pd-tab-panel').forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.querySelector('[data-tab-panel="' + target + '"]');
      if (panel) panel.classList.add('active');
    });
  });

  /* ---------- Collection filter panel toggle ---------- */
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.querySelector('[data-filter-panel]');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      filterPanel.classList.toggle('hidden');
    });
  }

  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

});
